import { useEffect, useState } from 'react';
import { Navigate } from 'react-router';


import { useAsyncEffect } from 'use-async-effect';

import { OnboardingRoutePath } from '@anyx/common-routing';
import { setWorkspace, useFirstWorkspace, useWorkspaceCtx } from '@anyx/common-workspace';
import { LoadWrapper } from '@anyx/shared-ui';
import { useLayoutStore } from '@anyx/shared-utils';

import { useWorkspaceHomepage } from '../../hooks';

export const IndexPage = () => {
  const { homepageLink } = useWorkspaceHomepage();
  const storeId = useWorkspaceCtx((state) => state.workspace?.storeId);
  const setShowFooter = useLayoutStore((state) => state.setShowFooter);

  const { getFirstWorkspace } = useFirstWorkspace();
  const [link, setLink] = useState<string | undefined>(undefined);
  const isLoading = !link;

  useEffect(() => {
    if (isLoading) {
      setShowFooter(false);
    }
    return () => setShowFooter(true);
  }, [isLoading, setShowFooter]);

  useAsyncEffect(
    async (isMounted) => {
      try {
        // If storeId already in context, redirect immediately
        if (storeId) {
          setLink(`/${storeId}${homepageLink}`);
          return;
        }

        const workspace = await getFirstWorkspace();

        if (!isMounted()) return;
        setWorkspace(workspace);

        if (!workspace) {
          setLink(OnboardingRoutePath().root().path);
          return;
        }

        // Include storeId in URL for merchant-scoped routes
        setLink(`/${workspace.storeId}${homepageLink}`);
      } catch (e) {
        if (!isMounted()) return;
        setLink(homepageLink);
      }
    },
    [getFirstWorkspace, homepageLink, storeId]
  );

  return (
    <LoadWrapper
      className="absolute inset-0 z-20 flex min-h-screen w-full justify-center overflow-hidden"
      loading={!link}
      message="This is Index Page loader"
    >
      <Navigate to={link as string} replace={true} />
    </LoadWrapper>
  );
};
